import "../assets/style/components/Carousel.scss";
import * as Icon from 'react-bootstrap-icons';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} custom-slick-arrow custom-slick-next`}
            style={style}
            onClick={onClick}
        >
            <Icon.ChevronRight size={24} />
        </div>
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} custom-slick-arrow custom-slick-prev`}
            style={style}
            onClick={onClick}
        >
            <Icon.ChevronLeft size={24} />
        </div>
    );
}

const Carousel = ({item}) => {
    return (
        <div className="carousel-container">
            {(() => {
                let images = item.images;
                if (typeof images === "string") {
                    try {
                        images = JSON.parse(images);
                    } catch {
                        images = [];
                    }
                }
                images = Array.isArray(images) ? images : [];
                if (images.length === 0) return null;

                const settings = {
                    dots: false,
                    infinite: images.length > 1,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: images.length > 1,
                    nextArrow: <NextArrow />,
                    prevArrow: <PrevArrow />
                };

                return (
                    <Slider {...settings} key={`slider-${item.id}`}>
                        {images.map((img, idx) => {
                            const src = `https://havredepriya.fr/api/getImage.php?file=${encodeURIComponent(img.startsWith('/') ? img.slice(1) : img)}`;
                            return (
                                <div key={idx} className="centered-row-container">
                                    <img
                                        src={src}
                                        alt={`Aperçu ${idx}`}
                                        className="carousel-image image"
                                    />
                                </div>
                            );
                        })}
                    </Slider>
                );
            })()}
        </div>
    )
}

export default Carousel;